export default function Footer({ onContactOpen }) {
  return (
    <footer data-testid="site-footer" className="bg-[#0F172A] text-[#F9F6F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <p className="font-display text-3xl md:text-4xl tracking-tight leading-tight">
              All We Do <span className="italic text-[#C86A53]">Is Write</span>
            </p>
            <p className="mt-4 max-w-md text-sm text-[#F9F6F0]/70 leading-relaxed font-light">
              Storytelling with purpose. We help growing businesses turn expertise
              and experience into stories that build trust and support growth.
            </p>
            <button
              data-testid="footer-cta"
              onClick={() => onContactOpen()}
              className="mt-8 inline-flex items-center px-6 py-3 text-xs uppercase tracking-[0.22em] font-semibold bg-[#C86A53] hover:bg-[#A65541] text-[#F9F6F0] transition-colors duration-300"
            >
              Let's Talk About Growth
            </button>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#F9F6F0]/60 mb-4">
              Navigate
            </p>
            <ul className="space-y-3 text-sm">
              {[
                { id: "problem", label: "The Problem" },
                { id: "insight", label: "The Insight" },
                { id: "services", label: "Services" },
                { id: "about", label: "About Rachel" },
              ].map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    data-testid={`footer-link-${l.id}`}
                    className="awd-link text-[#F9F6F0]/80 hover:text-[#F9F6F0]"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#F9F6F0]/60 mb-4">
              Contact
            </p>
            <ul className="space-y-3 text-sm text-[#F9F6F0]/80">
              <li>
                <a className="awd-link" href="mailto:hello@allwedoiswrite.com" data-testid="footer-email">
                  hello@allwedoiswrite.com
                </a>
              </li>
              <li>Based in the UK · Working globally</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#1E293B] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#F9F6F0]/50">
          <p>© {new Date().getFullYear()} All We Do Is Write. All rights reserved.</p>
          <p className="italic font-display text-[#F9F6F0]/70 text-sm">
            "Every organisation has stories worth telling."
          </p>
        </div>
      </div>
    </footer>
  );
}
